import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "./pages/Login";
import "./App.css";
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Registro = lazy(() => import("./pages/Registro"));
const Allievi = lazy(() => import("./pages/Allievi"));
const Corsi = lazy(() => import("./pages/Corsi"));
const Calendario = lazy(() => import("./pages/Calendario"));
const Contatori = lazy(() => import("./pages/Contatori"));
const Scadenze = lazy(() => import("./pages/Scadenze"));
const Importa = lazy(() => import("./pages/Importa"));
const Revisione = lazy(() => import("./pages/Revisione"));
const Attestati = lazy(() => import("./pages/Attestati"));
const CatalogoEdizioni = lazy(() => import("./pages/CatalogoEdizioni"));
const Documentazione = lazy(() => import("./pages/Documentazione"));
const JformaCorsi = lazy(() => import("./pages/JformaCorsi"));
const Fatturazione = lazy(() => import("./pages/Fatturazione"));
const Collaboratori = lazy(() => import("./pages/Collaboratori"));
const Impostazioni = lazy(() => import("./pages/Impostazioni"));
const Anagrafiche = lazy(() => import("./pages/Anagrafiche"));
const FadTrimestrali = lazy(() => import("./pages/FadTrimestrali"));
const Elearning = lazy(() => import("./pages/Elearning"));
const Sottoscrizioni = lazy(() => import("./pages/Sottoscrizioni"));
const Aziende = lazy(() => import("./pages/Aziende"));
const LearnerLogin = lazy(() => import("./pages/learner/LearnerLogin"));
const LearnerAula = lazy(() => import("./pages/learner/LearnerAula"));
const LearnerCorso = lazy(() => import("./pages/learner/LearnerCorso"));
const Verifica = lazy(() => import("./pages/Verifica"));
const Conformita = lazy(() => import("./pages/Conformita"));

const PageLoader = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50" data-testid="page-loader">
    <Loader2 className="h-8 w-8 animate-spin text-[#D9531E]" />
  </div>
);

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#D9531E]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function OperatorOnly({ children }) {
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function StaffOnly({ children }) {
  const { user } = useAuth();
  if (user?.role === "collaboratore") return <Navigate to="/" replace />;
  return children;
}

function RoleHome() {
  return <Dashboard />;
}

function LoginGate() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-slate-900" />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/" element={<Protected><RoleHome /></Protected>} />
          <Route path="/registro" element={<Protected><OperatorOnly><Registro /></OperatorOnly></Protected>} />
          <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
          <Route path="/catalogo" element={<Protected><OperatorOnly><CatalogoEdizioni /></OperatorOnly></Protected>} />
          <Route path="/documentazione" element={<Protected><OperatorOnly><Documentazione /></OperatorOnly></Protected>} />
          <Route path="/fad-trimestrali" element={<Protected><OperatorOnly><FadTrimestrali /></OperatorOnly></Protected>} />
          <Route path="/jforma-corsi" element={<Protected><OperatorOnly><JformaCorsi /></OperatorOnly></Protected>} />
          <Route path="/fatturazione" element={<Protected><StaffOnly><Fatturazione /></StaffOnly></Protected>} />
          <Route path="/allievi" element={<Protected><OperatorOnly><Allievi /></OperatorOnly></Protected>} />
          <Route path="/anagrafiche" element={<Protected><OperatorOnly><Anagrafiche /></OperatorOnly></Protected>} />
          <Route path="/corsi" element={<Protected><OperatorOnly><Corsi /></OperatorOnly></Protected>} />
          <Route path="/contatori" element={<Protected><StaffOnly><Contatori /></StaffOnly></Protected>} />
          <Route path="/scadenze" element={<Protected><OperatorOnly><Scadenze /></OperatorOnly></Protected>} />
          <Route path="/importa" element={<Protected><StaffOnly><Importa /></StaffOnly></Protected>} />
          <Route path="/collaboratori" element={<Protected><AdminOnly><Collaboratori /></AdminOnly></Protected>} />
          <Route path="/impostazioni" element={<Protected><AdminOnly><Impostazioni /></AdminOnly></Protected>} />
          <Route path="/revisione" element={<Protected><OperatorOnly><Revisione /></OperatorOnly></Protected>} />
          <Route path="/attestati" element={<Protected><OperatorOnly><Attestati /></OperatorOnly></Protected>} />
          <Route path="/elearning" element={<Protected><OperatorOnly><Elearning /></OperatorOnly></Protected>} />
          <Route path="/aziende" element={<Protected><OperatorOnly><Aziende /></OperatorOnly></Protected>} />
          <Route path="/sottoscrizioni" element={<Protected><OperatorOnly><Sottoscrizioni /></OperatorOnly></Protected>} />
          <Route path="/conformita" element={<Protected><OperatorOnly><Conformita /></OperatorOnly></Protected>} />
          <Route path="/studente/login" element={<LearnerLogin />} />
          <Route path="/studente" element={<LearnerAula />} />
          <Route path="/studente/corso/:subscriptionId" element={<LearnerCorso />} />
          <Route path="/verifica" element={<Verifica />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
